import React, { useState } from "react";
import { RevenueGrowth } from "./components/revenue-growth";
import { ClientRevenueChart } from "./components/client-revenue-chart";

export default function RevenueDashboard() {
  return (
    <div className="flex-1 overflow-auto space-y-6">
      <RevenueGrowth />
      <ClientRevenueChart />
    </div>
  );
}
